import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Amplify, { Auth } from "aws-amplify";
import { toast } from 'react-toastify';
// conversion tracking 
import LinkedInTag from 'react-linkedin-insight';

// API Urls
import APIUrls from "../../constants/ApiUrls";
import LoaderButton from "../../components/LoaderButton";
import "./Confirm.scss";

import CamelLogo from "../../assets/images/main-logo-white.png";

// conversion tracking
// LinkedIn and Facebook
if (process.env.REACT_APP_ENVIRONMENT === "production") {
  LinkedInTag.init(1782764);
  LinkedInTag.track(1912180);
}

const modalStyle = () => {
  // we use some psuedo random coords so nested modals
  // don't sit right on top of each other.
  let top = window.innerHeight / 2 - 214;
  let left = window.innerWidth / 2 - 230;

  return {
    position: 'fixed',
    width: 460,
    zIndex: 1040,
    top: top + 'px',
    bottom: top + 'px',
    left: left + 'px',
  };
};

const oauthSettings = {
  domain: 'foo.domain.com',//'auth.contentcamel.io',
  scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
  redirectSignIn: APIUrls.clientLogin,
  redirectSignOut: APIUrls.clientRoot,
  responseType: 'code' // or token
};

const authSettings = {
  mandatorySignIn: false,
  region: "us-west-2",
  userPoolId: "us-west-2_X9qh8CBP6",
  identityPoolId: "us-west-2:0b763a53-720d-440d-a083-983740ec27d1",
  userPoolWebClientId: "g9g7hl6e7mlhauhg4nff6fs53",
};

export default class Confirm extends Component {
  constructor(props) {
    super(props);

    if (!props.location.state) {
      props.history.push('/login');
    }

    this.state = {
      isLoading: false,
      userInfo: props.location.state ? props.location.state.user : null
    }
  }

  onClickResend = async () => {
    try {
      authSettings.userPoolId = this.state.userInfo.userPoolId;
      authSettings.identityPoolId = this.state.userInfo.identityPoolId;
      authSettings.userPoolWebClientId = this.state.userInfo.appClientId;
      oauthSettings.domain = this.state.userInfo.appClientDomain;

      Amplify.configure({
        Auth: authSettings
      });

      await Auth.resendSignUp(this.state.userInfo.ownerEmail);

      toast.success('Re-sent the verification link successfully: ', {
        position: toast.POSITION.TOP_RIGHT
      });
    } catch (e) {
      toast.error('Failed to re-send the link: ' + e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  render() {
    const { isLoading } = this.state;
    return (
      <div className="Confirm">
        <Modal
          onHide={this.close}
          style={modalStyle()}
          aria-labelledby="modal-label"
          show={true}
        >
          <div className="modal-header">
            <img src={CamelLogo} alt="camel logo" />
          </div>
          <div className="content">
            <h3>You are signed up!</h3>
            <p className="sub-title">Please, check your email</p>
            <div className="description">
              <p>A <strong>confirmation email</strong> has been sent to your inbox</p>
              <p>Go ahead and <strong>click the link in that email</strong>.</p>
            </div>
            <p>Didn't find the message in your inbox?</p>
            <LoaderButton
              block
              type="submit"
              isLoading={isLoading}
              text="RE-SEND THE EMAIL"
              loadingText="SEND EMAIL..."
              className="btn-danger"
              onClick={this.onClickResend}
            />
          </div>
        </Modal>
      </div>
    );
  }
}
